import { EditableText, InnerBlocks, useInnerBlocks, usePostTitleEditor } from "eddev/blocks"
import { PropsWithChildren } from "react"
import { twMerge } from "tailwind-merge"

export const HeaderBasic = ({
  title,
  className,
  hasTopSpacing = true,
  children,
}: PropsWithChildren<{
  title?: string
  className?: string
  hasTopSpacing?: boolean
}>) => {
  const inner = useInnerBlocks()
  const hasContents = inner?.filter((b) => b.innerHTML !== "</p>\n")?.length! > 0 || !!children

  return (
    <div className={twMerge("grid-auto", className)}>
      <div
        className={twMerge(
          "col-span-12 md:col-span-6 md:col-start-4 flex flex-col gap-5",
          hasTopSpacing && "mt-pageHeaderBasicMT",
          hasContents && "pb-7",
        )}
      >
        <div className="type-title-xxl w-full">
          {env.admin ? (
            <EditableText store={usePostTitleEditor()} as="span" placeholder="Enter title" plainText />
          ) : (
            title
          )}
        </div>
        {(env.admin || hasContents) && (
          <div className="w-full gap-3 flex flex-col [&_p]:!type-body-m [&_a]:underline [&_button]:my-0 [&_button]:!w-fit [&_button]:!justify-start">
            <InnerBlocks
              allowedBlocks={["core/paragraph", "content/button"]}
              template={[["core/paragraph", { placeholder: "Enter text here" }]]}
            />
            {children}
          </div>
        )}
      </div>
    </div>
  )
}
